<template>
  <div>
    <template v-if="hasTicket">
      <input class="w-8 py-4 px-2 bg-gray-200" type="number" v-model="adult" disabled />
      <span class="ml-2">{{$t('tour_persons')}}</span>
    </template>
    <template v-else>
      <span>{{$t('tour_fare_labels_adult')}}</span>
      <input v-model="adult" class="w-8 py-4 px-2 bg-gray-200 ml-2 capacity" type="number" min="0" v-bind:max="max" />
      <span class="ml-2">{{$t('tour_fare_labels_child')}}</span>
      <input v-model="child" class="w-8 py-4 px-2 bg-gray-200 ml-2 capacity" type="number" min="0" v-bind:max="max" />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    max: {
      type: Number,
      required: true
    }
  },
  created () {
    if (this.ticket && this.ticket.count)  {
      this.adult = this.ticket.count
    }
  },
  computed: {
    ...mapGetters({
      hasTicket: 'user/hasTicket',
      ticket: 'user/getTicket'
    }),
    adult: {
      get () {
        return this.$store.getters['reservation/getAdult']
      },
      set (value) {
        const adult = parseInt(value)
        const child = parseInt(this.$store.getters['reservation/getChild'])
        if (adult + child > this.max) {
          value = this.max - child
          this.$store.dispatch('reservation/updateAdult', value)
          this.updatePeople(value, child)
        } else {
          this.$store.dispatch('reservation/updateAdult', value)
        }
      }
    },
    child: {
      get () {
        return this.$store.getters['reservation/getChild']
      },
      set (value) {
        const adult = parseInt(this.$store.getters['reservation/getAdult'], 10)
        const child = parseInt(value, 10)
        if (adult + child > this.max) {
          value = this.max - adult
          this.$store.dispatch('reservation/updateChild', value)
          this.updatePeople(adult, value)
        } else {
          this.$store.dispatch('reservation/updateChild', value)
        }
      }
    }
  },
  methods: {
    updatePeople: function(adult,child){
      this.adult = adult
      this.child = child
    }
  }
}
</script>

<style>
input[type="number"].capacity::-webkit-outer-spin-button,
input[type="number"].capacity::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"].capacity {
  -moz-appearance:textfield;
}
</style>
